/* tslint:disable */
require('./FieldUrlRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_932b81a7',
  relative: 'relative_932b81a7',
  image: 'image_932b81a7',
  link: 'link_932b81a7',
  fabricIcon: 'fabricIcon_932b81a7',
};

export default styles;
/* tslint:enable */